const serverObj = (e) => ({ id: e.errorCode, msg: '', isError: true });

/**
  * validate method for frontend and backend rules
  * @param {string} fieldID
  * @param {object} formikData
  * @param {object} beErrors
  * @param {object} rules
  * @param {object} feRuleConfig
  * @param {boolean} isBorder
  * @param {Function} tran
  * @returns object
  */
export const getErrors = (fieldID, formikData, beErrors, rules, feRuleConfig, isBorder, tran) => {
  let controlErrors = [];
  let serverErrors = [];
  if (formikData.errors[fieldID] && formikData.touched[fieldID]) {
    controlErrors = [
      {
        id: formikData.errors[fieldID],
        msg: !isBorder && tran(feRuleConfig[formikData.errors[fieldID]]),
        isError: true,
      },
    ];
  }
  if (beErrors) {
    serverErrors = beErrors
      .filter((e) => rules?.indexOf(e.errorCode) > -1)
      .map((e) => (serverObj(e)));
  }
  return [...controlErrors, ...serverErrors];
};

export const getFormikArrayFieldErrors = ({ fieldID, index, formik, serverErros, rules, formRuleConfig, isBorder, t }) => {
  let controlErrors = [];
  let serverErrorsMapped = [];
  const errorId = formik.errors[fieldID]?.[index];
  const isTouched = formik.touched[fieldID]?.[index];
  if (errorId && isTouched) {
    controlErrors = [
      {
        id: errorId,
        msg: !isBorder && t(formRuleConfig[errorId]),
        isError: true,
      },
    ];
  }
  if (serverErros) {
    serverErrorsMapped = serverErros
      .filter((e) => rules?.indexOf(e.errorCode) > -1)
      .map((e) => (serverObj(e)));
  }
  return [...controlErrors, ...serverErrorsMapped];
};

export const getErrorsDup = (fieldID, formikData, beErrors, rules, feRuleConfig, isBorder, tran) => {
  let controlErrors = [];
  let serverErrors = [];
  if (formikData.errors[fieldID]) {
    controlErrors = [
      {
        id: formikData.errors[fieldID],
        msg: !isBorder && tran(feRuleConfig[formikData.errors[fieldID]]),
        isError: true,
      },
    ];
  }
  if (beErrors) {
    serverErrors = beErrors
      .filter((e) => rules?.indexOf(e.errorCode) > -1)
      .map((e) => (serverObj(e)));
  }
  return [...controlErrors, ...serverErrors];
};

/**
  * validate method for frontend and backend rules
  * @param {string} fieldID
  * @param {object} formikData
  * @param {object} beErrors
  * @param {object} rules
  * @param {object} feRuleConfig
  * @param {boolean} isBorder
  * @param {Function} tran
  * @returns object
  */
export const getAmountFieldErrors = (errParms, isBorder) => {
  const { formikData, fieldID, feRuleConfig, amountLength, tran, beErrors, rules } = errParms;
  let controlErrors = [];
  let serverErrors = [];
  if (formikData.errors[fieldID] && formikData.touched[fieldID]) {
    controlErrors = [
      {
        id: formikData.errors[fieldID],
        msg: !isBorder && tran(
          feRuleConfig[formikData.errors[fieldID]],
          { maxLength: amountLength[0], decimalLength: amountLength[1] },
        ),
        isError: true,
      },
    ];
  }
  if (beErrors) {
    serverErrors = beErrors
      .filter((amtFieldErr) => rules.indexOf(amtFieldErr.errorCode) > -1)
      .map((amtFieldErr) => ({
        id: amtFieldErr.errorCode,
        msg: '',
        isError: true,
      }));
  }
  return [...controlErrors, ...serverErrors];
};
export const getErrorsObj = ({ fieldID, formik, serverErrors, rules,
  formRuleConfig, isBorder, tran }) => {
  let controlErrors = [];
  let serverErrs = [];
  if (formik.errors[fieldID] && formik.touched[fieldID]) {
    controlErrors = [
      {
        id: formik.errors[fieldID],
        msg: !isBorder && tran(formRuleConfig[formik.errors[fieldID]]),
        isError: true,
      },
    ];
  }
  if (serverErrs.length > 0) {
    serverErrs = serverErrors
      .filter((e) => rules.indexOf(e.errorCode) > -1)
      .map((e) => ({
        id: e.errorCode,
        isError: true,
        msg: '',
      }));
  }
  return [...controlErrors, ...serverErrs];
};
export const getAmountFieldErrorsObj = ({ fieldID, formik, serverErrors, rules,
  formRuleConfig, isBorder, tran }, amountFieldLength) => {
  let controlErrors = [];
  let serverErrs = [];
  if (formik.errors[fieldID] && formik.touched[fieldID]) {
    controlErrors = [
      {
        id: formik.errors[fieldID],
        msg: !isBorder && tran(
          formRuleConfig[formik.errors[fieldID]],
          { maxLength: amountFieldLength[0], decimalLength: amountFieldLength[1] },
        ),
        isError: true,
      },
    ];
  }
  if (serverErrs.length > 0) {
    serverErrs = serverErrors
      .filter((amtFieldErrObj) => rules.indexOf(amtFieldErrObj.errorCode) > -1)
      .map((amtFieldErrObj) => ({
        id: amtFieldErrObj.errorCode,
        isError: true,
        msg: '',
      }));
  }
  return [...controlErrors, ...serverErrs];
};
/**
  * Control unexceptional Server Error
  * @param {object} error
  * @returns
  */
export const processError = (error) => {
  if (error && error.response && Array.isArray(error.response.data.errors)) {
    return error.response.data.errors.map((item) => {
      const responseItem = item;
      if (item.addlDetails) {
        const dynamic = item.addlDetails.split('|');
        const i18nObj = {};
        dynamic.forEach((value, index) => {
          i18nObj[`Key${index + 1}`] = value;
        });
        responseItem.alterObj = i18nObj;
      } else {
        responseItem.alterObj = null;
      }
      return responseItem;
    });
  }
  if (error && error.response && !Array.isArray(error.response.data.errors)) {
    return [
      {
        errorCode: 'UNKNOWN_ERROR',
        errorMessage: 'Operation could not be completed due to an unexpected error.',
        errorMessageId: 'static:GENERIC.NOTIFICATION',
        type: '',
        alterObj: null,
      },
    ];
  }
  return [
    {
      errorCode: 'UNKNOWN_ERROR',
      errorMessage: 'Something went wrong, please try again.',
      errorMessageId: 'COMMON_EXCEPTION_GENERIC',
      type: '',
      alterObj: null,
    },
  ];
};

/**
  * validate method for frontend and backend rules
  * @param {string} fieldID
  * @param {object} formikData
  * @param {object} beErrors
  * @param {object} rules
  * @param {object} feRuleConfig
  * @param {boolean} isBorder
  * @param {Function} tran
  * @returns object
  */
export const getErrorsPage = (fieldID, formikData, beErrors, rules, feRuleConfig, isBorder, tran) => getErrorsDup(fieldID, formikData, beErrors, rules, feRuleConfig, isBorder, tran);
